import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-images_style_2",
  "use": "icon-images_style_2-usage",
  "viewBox": "0 0 20 20.001",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20.001\" id=\"icon-images_style_2\">\r\n  <path id=\"icon-images_style_2_联合_71\" data-name=\"联合 71\" class=\"cls-1\" d=\"M20,20H0V0H20V20h0Zm-1.176-1.176V10.589H10.589v8.235Zm-17.647,0H9.411V10.589H1.176ZM18.823,9.411V1.176H10.589V9.411Zm-9.412,0V1.176H1.176V9.411Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol